
<template>
  <div>
    <div class="app-title">
      <em-view-title></em-view-title>
    </div>
    
    <section class="app-content">
      <div class="card-columns">
        <EmCardRouter v-for="cardData in this.routerCards" :key="cardData.id" :cardData="cardData"></EmCardRouter>
        <EmCardEdit v-for="cardData in this.editCards" :key="cardData.id" :cardData="cardData"></EmCardEdit>
      </div>
    </section>
    
  </div>
</template>


<script>
import { mapState, mapActions, mapMutations } from "vuex";
import EmViewTitle from "@/components/em/EmViewTitle";
import EmCardEdit from "@/components/em/EmCard/Edit";
import EmCardRouter from "@/components/em/EmCard/Router";
export default {
  name: "emCardSetting",
  components: {EmViewTitle, EmCardEdit,EmCardRouter},
  methods: {
    ...mapActions("emMenu", ["retrieveForRouterCards","retrieveForEditCards"]),
    ...mapMutations("emMenu",["setEmMenuBadge","setStateAttribute"]),
    retrieveData(){
      let menuId = this.$route.query.menuId
      if(menuId){
        this.retrieveForEditCards(menuId);
        this.retrieveForRouterCards(menuId);
      }
    }
  },
  computed: {
    ...mapState({
      routerCards: state => state.emMenu.routerCards,
      editCards: state => state.emMenu.editCards
    })
  },
  watch: {
    '$route' (to, from) {
      this.retrieveData()
    }
  },
  mounted() {
    this.retrieveData()
  }
};
</script>


